import { FC } from "react";

import { CollapsePanel } from "../../common";

export const PrimaryOnmetaKYCFAQ: FC = () => {
  return (
    <div className="flex flex-col gap-8">
      <h4 className="font-bold text-2xl px-4">Still have questions?</h4>

      <div className="flex flex-col">
        <CollapsePanel
          title="Why do I need to get verified?"
          className="px-4"
          collapseClassName="mb-4"
          expandedClassName="border-b border-gray-100 pb-8 mb-8"
        >
          To receive INR payouts in your personal bank account in India (or USDC
          payouts to your wallet) - up to the equivalent of EUR{" "}
          <span className="font-extrabold">15,000 monthly</span>.<br />
          <br />
          It helps us to protect against fraud, ensures compliance with
          financial regulations, and maintains a safe environment for all users
          (including you!).
        </CollapsePanel>

        <CollapsePanel
          title="What documents are required for verification?"
          className="px-4"
          collapseClassName="mb-4"
          expandedClassName="border-b border-gray-100 pb-8 mb-8"
        >
          Your <span className="font-extrabold">PAN card</span> and{" "}
          <span className="font-extrabold">Aadhaar card</span> are both
          required.
          <br />
          <br />
        </CollapsePanel>

        <CollapsePanel
          title="How much time does verification take?"
          className="px-4"
        >
          Usually, it takes just a couple of minutes, including photographing
          your documents and verifying them. Better document quality will speed
          up your verification process.
        </CollapsePanel>
      </div>
    </div>
  );
};
